import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  var swiper = new Swiper(".mySwiper", {
    loop: true,
    // spaceBetween: 10,
    freeMode: true,
    watchSlidesProgress: true,
    grid: {
      rows: 2,
      fill: "row",
    },
    slidesPerView: 4,

    breakpoints: {
      992: {
        slidesPerView: 7,
      },
    },
  });
  var swiper2 = new Swiper(".mySwiper2", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
    modules: [Navigation, Thumbs],
  });
});
